<template>
<el-collapse-item :name="item.id">
    <template slot="title">
      <div class="row">
        <div class="col s9">{{ item.cognome }}&#160;{{ item.nome }}</div>
        <div class="col s2 yo-align-left">{{item.dataricovero | data('YYYY')}}-{{item.ncartellaclinica}}</div>
        
        <div class="col s1 red yo-text-bold yo-align-right" v-if="item.nr_numero>10" style="">{{item.nr_numero}}&#160;&#160;<i class="material-icons" style="float:right;margin-right:12px;line-height:48px;">error</i></div>
        <div class="col s1 tree_poppy yo-text-bold yo-align-right" v-if="item.nr_numero>0 && item.nr_numero<11" style="">{{item.nr_numero}}&#160;&#160;<i class="material-icons" style="float:right;margin-right:12px;line-height:48px;">warning</i></div>
        <div class="col s1 grees yo-text-bold yo-align-right" v-if="item.nr_numero==0" style=""><i class="material-icons" style="float:right;margin-right:12px;line-height:48px;">done</i></div>
      </div>
    </template>
    
    <div class="row">

      <div class="col s3 yo-text-bold">ID</div>
      <div class="col s9">{{item.id}} <!-- {{item.nimv36}} --></div>

      <div v-if="item.vonnumber>0" class="col s3 yo-text-bold">ID VON</div>
      <div v-if="item.vonnumber>0" class="col s9">{{item.vonnumber}}</div>

      <div class="col s3 yo-text-bold">SESSO</div>
      <div class="col s9">{{item.sex | answerValue('sex',$teras._variabile)}} </div>

      <div class="col s3 yo-text-bold">DATA DI NASCITA</div>
      <div class="col s9">{{item.datanascita | data('DD MMMM YYYY')}} </div>

      <div class="col s3 yo-text-bold">DATA COMPIMENTO 28 giorno</div>
      <div class="col s9">{{$centro.giorno28(item.datanascita) | data('DD MMMM YYYY')}}</div>

      <div class="col s3 yo-text-bold">DATA COMPIMENTO 36 sett. PMA</div>
      <div class="col s9">{{$centro.settimana36(item.datanascita,item.gaweeks,item.gadays) | data('DD MMMM YYYY')}}</div>

      <div class="col s3 yo-text-bold">PESO ALLA NASCITA</div>
      <div class="col s9">{{item.bwgt}} g</div>

      <div class="col s3 yo-text-bold">ETÀ GESTAZIONALE</div>
      <div class="col s9">{{item.gaweeks}}+{{item.gadays}}</div>
<!--
      <el-tooltip content="Calcolato in base al peso ed all'età gestazionale" placement="left"><div class="col s3 yo-text-bold">TIPOLOGIA PAZIENTE</div></el-tooltip>
      <div class="col s9">{{$centro.tipoPaziente(item.bwgt,item.gaweeks,item.gadays)}}</div>
-->
      <div class="col s3 yo-text-bold">SGA</div>
      <div class="col s9">{{item.sga}}</div>

      <div class="col s3 yo-text-bold">DOMANDE NON RISPOSTE</div>
      <div class="col s9 red yo-text-bold yo-text-xxl" v-if="item.nr_numero>10">{{item.nr_numero}} </div>
      <!-- <div class="col s9 tree_poppy yo-text-bold yo-text-l" v-if="item.nr_numero>0 && item.nr_numero<11">{{item.nr_numero}} </div> -->
      <div class="col s9" v-if="item.nr_numero==0">Complimenti la scheda è completata!</div>
      <div class="col s9" v-if="item.nr_numero>0 && item.nr_numero<11">
        <ol style="margin:0;padding: 0 0 0 24px;">
        <li v-for="singleName in item.nr_nome.split(',')" v-html="labelName(singleName)" :key="singleName"></li>
        </ol>
        <!-- {{item.nr_nome}}  {{labelName}}-->
        </div>

      <div class="col s3 yo-text-bold">ULTIMO AGGIORNAMENTO</div>
      <div class="col s9">{{item.modificatoil  | data('DD MMMM YYYY HH:mm')}} </div>
   </div>

   <div class="row" style="margin-top:12px;border-top:1px solid #5288C6;">
      <div class="col s2" style="margin-top:12px;">
        <router-link class="button yo-color-primary yo-text-bold" :to="'/scheda-datigenerali/'+item.id" ><i class="material-icons " style="float:left;padding:0 12px 0 18px;" >folder_open</i>DATI GENERALI</router-link>
      </div>
      <div class="col s2" style="margin-top:12px;">
        <router-link class="button yo-color-primary yo-text-bold" :to="'/scheda-perinatale/'+item.id" ><img src="../assets/ico-perinatale.png" class="material-icons " style="float:left;padding:0 12px 0 18px;height:24px;" />DATI PERINATALI</router-link>
      </div>
      <div class="col s2" style="margin-top:12px;">
        <router-link class="button yo-color-primary yo-text-bold" :to="'/scheda-salaparto/'+item.id" ><img src="../assets/ico-salaparto.png" class="material-icons " style="float:left;padding:0 12px 0 18px;height:24px;" >SALA PARTO</router-link>
      </div>
      <div class="col s2" style="margin-top:12px;">
        <router-link class="button yo-color-primary yo-text-bold" :to="'/scheda-decorso/'+item.id" ><i class="material-icons " style="float:left;padding:0 12px 0 18px;" >hotel</i>DECORSO CLINICO</router-link>
      </div>
      <div class="col s2" style="margin-top:12px;">
        <router-link class="button yo-color-primary yo-text-bold" :to="'/scheda-dimissione/'+item.id" ><i class="material-icons " style="float:left;padding:0 12px 0 18px;" >child_friendly</i>DIMISSIONE</router-link>
      </div>
      <div class="col s2" style="margin-top:12px;" v-if="item.fdisp==2">
        <router-link class="button yo-color-primary yo-text-bold" :to="'/scheda-trasferimento/'+item.id" ><i class="material-icons " style="float:left;padding:0 12px 0 18px;" >directions_bus</i>TRASFERIMENTO</router-link>
      </div>



    </div>


</el-collapse-item>
<!--
<div class="row" style="padding:0 6px;margin:0;">

  <div class="col s5 yo-text-m yo-spacing-xs yo-color-primary">{{ item.codicefiscale }}</div>   
  <div class="col s2m yo-text-n yo-spacing-xs yo-color-primary">{{ item.cognome }}&#160;{{ item.nome }}</div>   
  <div class="col s2m yo-text-n yo-spacing-xs yo-color-primary">{{ item.citta }}&#160;</div>   

     

  <div class="col s2 yo-align-right" style="">
      
      <router-link :to="'/domanda-edit/'+item.id" style="padding-right:20px;"><i class="material-icons yo-color-primary" >edit</i> </router-link>     
      <i class="material-icons crimson" @click="rowDel()" >delete</i>
      
      <i class="material-icons yo-color-primary" @click="loadRow()" >edit</i>
   </div>

    <div class="col s12 yo-text-s" style="padding:6px;">{{ item.id }}</div>
 </div>  
 -->
</template>


<script>

export default {
  name: 'item-elenco',
  created () {
    this.$teras.pageHeader = 80
  },
  mounted () {
    this.$emit('scrollTop', 0)
  },
  props: {
    item: Object
  },
  methods: {
    rowDel () {
      this.$confirm('La variabile "'+this.item.nome+'" verrà eliminata?', 'Warning', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        var parent = this
        this.$axios.deleteRow(this.item.id,'variabile').then((data) => {
            this.$teras.event.emit('variabile-saved')
        })
      }).catch(() => {
        this.$message({
            type: 'info',
            message: 'Operazione annullata'
        })         
      })
      
    },
    loadScheda(scheda) {
        this.$router.push('/scheda-'+scheda+'/'+this.item.id)


        
    },
    socioNew() {
      this.$confirm('Sei sicuro di inserire come nuovo socio:'+this.item.cognome+' '+this.item.nome+'?', 'Warning', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(async () => {
        await this.$axios.query('doQuery',`INSERT INTO statoiscrizione (contatto,societa,stato,tiposocio,inseritoil,primoanno) VALUES(←id,←societa,'DA APPROVARE',1,→inseritoil,→primoanno)`,{id: this.item.id, societa: this.$socio.societa, inseritoil:this.$moment(),primoanno: this.$moment().format('YYYY')})  
        this.$socio.contatto.load(this.item.id).then((data) => {
          this.$teras.socio = true
          this.$router.push('/home')
        })
        
      }).catch(() => {
        this.$message({
            type: 'info',
            message: 'Operazione annullata'
        })         
      })

        
    },
    labelName(nome){
      let label =  (this.$teras.getItemFromArrayObject(nome,'nome',this.$teras._variabile)).domanda
      return label
    }
  }
}
</script>

<style>
.evento-title{font-size:1.6rem;font-weight:bold;color:#003264;
}.row-item{
  margin:0 0 10px 0;
}.row-item .title{
  color:#29B7C4;
  line-height: 1.4rem;
  font-size: 1.4rem;
  padding:0;
}.row-item .autori{
  line-height: 1.1rem;
  font-size: 1.2rem;
  padding-top:2px;
  text-transform: capitalize;
  text-align: left;
}.row-item .codice{
  font-size:1.1rem;
  padding-top:10px;
}
</style>
